var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M457.028 239.808c-58.373 76.469-138.845 157.397-217.242 217.241 124.183 10.007 227.247-93.083 217.242-217.241z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.975 13.294c-33.042-33.042-102.488 2.952-142.725 27.507a235.006 235.006 0 0 1 35.66 20.547c15.593-8.646 69.142-35.424 81.793-22.781 16.935 16.935-29.565 94.651-43.478 115.778-65.529-112.843-222.707-134.794-316.704-40.802-56.934 56.933-71.376 137.183-48.666 206.184C30 369.125-25.638 460.089 13.272 498.996c98.059 98.061 583.876-387.529 485.703-485.702zM38.546 473.724c-16.553-16.551 27.542-91.575 43.465-115.72 16.756 28.872 41.006 54.035 72.255 72.219-62.869 41.252-105.824 53.398-115.72 43.501z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e0db679c7c88f09b5ff5e0d0317d7cd.svg";
export { ForwardRef as ReactComponent };